import { render, staticRenderFns } from "./BulkUploadStudent.vue?vue&type=template&id=3b37d435&scoped=true"
import script from "./BulkUploadStudent.vue?vue&type=script&lang=js"
export * from "./BulkUploadStudent.vue?vue&type=script&lang=js"
import style0 from "./BulkUploadStudent.vue?vue&type=style&index=0&id=3b37d435&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b37d435",
  null
  
)

export default component.exports